 export const initialReviews = [
    {
      id: 1,
      name: 'Abdessamad ELAM',
      rating: 5,
      comment: 'Thank you for the support during the training.',
      date: '2024-01-15'
    },
    {
      id: 2,
      name: 'Jorick Butron',
      rating: 4,
      comment: 'The training session was well delivered by the tutor, and I greatly appreciated the very attentive support from Mr. lijjash Ahamed of TVE. Thank you, sir, and thanks to the entire TVE team. I have approved and recommended this institution to my friends for safety training courses.',
      date: '2024-01-10'
    },
    {
      id: 3,
      name: 'Ghulam Murtaza',
      rating: 5,
      comment: 'Satisfied with service. Response was always quick. Excellent training and material provided',
      date: '2024-01-05'
    },
    {
      id: 4,
      name: 'Sivakumar Ayyappan',
      rating: 5,
      comment: '',
      date: '2024-01-02'
    },
    {
      id: 5,
      name: 'nethaji m',
      rating: 5,
      comment: 'Recently I have completed ISO 4500:2018 course in tve certification from tve all members are very supportive for knowledge sharing and course completion. Value for time and money for ISO certification thanks for tve',
      date: '2023-12-28'
    },
    {
      id: 6,
      name: 'VIKASH KUMAR',
      rating: 4,
      comment: 'I recently completed the ISO 9001:2015 Lead Auditor training course with TVE Training Institute and am pleased to share my highly positive experience. From start to finish, the entire learning process was smooth, professional, and extremely informative. The course material was well-structured, up-to-date, and easy to follow, even in an online format, which is a testament to the quality of TVE s educational resources. The trainers were not only knowledgeable but also approachable, always available to clarify doubts and guide us through complex topics. This level of support made the learning experience both enriching and effective.',
      date: '2023-12-25'
    },
    {
      id: 7,
      name: 'Suresh Kumar Muniyandi',
      rating: 5,
      comment: 'I recently completed my ISO 9001 2015 lead auditor courses through TVE Certification Services Pvt Ltd. They have training time and can conduct lot assessments in practice. During training, tips, tricks, and guides are used to prepare for exams. Thank you for your assistance in passing the exam with ease.',
      date: '2023-12-20'
    },
    {
      id: 8,
      name: 'Lisa Anderson',
      rating: 4,
      comment: 'Solid product with great features. The learning curve was minimal and integration was seamless with our existing systems and workflow.',
      date: '2023-12-15'
    },
    {
      id: 9,
      name: 'esam saeed',
      rating: 5,
      comment: 'I attended an online course with this center and it was excellent. The instructors were professional, the sessions were clear and well-organized, and the support team was always responsive. Highly recommend',
      date: '2023-12-10'
    },
    {
      id: 10,
      name: 'Mukesh V',
      rating: 5,
      comment: 'I recently completed the ISO 9001:2015 Lead Auditor training course with TVE Training Institute and successfully passed the online exam. The entire experience was smooth, professional, and very informative. The course material was well-structured, up-to-date, and easy to follow, even in an online format. course training slot and timing was very appreciable and helpful for regular working people., The trainer Mr. Karthikeyan was very knowledgeable and supportive, always available to clarify doubts and guide us through complex topics. I highly recommend TVE to anyone looking to do professional auditor training in ISO standards. Special Thanks to Mr. Karthikeyan for complete support.',
      date: '2023-12-05'
    },
    {
      id: 11,
      name: 'Jojin John',
      rating: 5,
      comment: 'Thanking TVE and Team for the guidance and support for the lead auditor course completion.',
      date: '2023-11-30'
    },
    {
      id: 12,
      name: 'SURESH KUMAR',
      rating: 5,
      comment: 'TVE Training Institute team members approach was good and the trainers were knowledgeable and supportive, always available to clarify doubts and guide us through complex topics, TVE will be a best one if anyone looking to pursue professional auditor training in ISO standards.',
      date: '2023-11-25'
    },
    {
      id: 13,
      name: 'Rabintor',
      rating: 5,
      comment: 'I recently had the opportunity to travel with the TVE Certification team for the ISO 9001 Lead Auditor training course. The training was highly informative, well-structured, and delivered with exceptional professionalism. The support team was equally outstanding, ensuring a smooth and engaging learning experience throughout. I am delighted to have successfully earned my certification, and I look forward to joining their ISO 14001 and ISO 45001 courses in the near future.',
      date: '2023-11-25'
    },
    {
      id: 14,
      name: 'FERDIN VIRGIL',
      rating: 5,
      comment: 'I have successfully completed the ISO 9001:2015 certification through an online program offered by TVE Certification Services. The entire registration process was smooth and can be completed either via online chat or WhatsApp',
      date: '2023-11-25'
    },
    {
      id: 15,
      name: 'Mohammad Mahfooz',
      rating: 5,
      comment: 'I m pleased to share that I successfully completed the ISO 45001 Lead Auditor course with TVE Certification Institute. The training was well-structured, professionally delivered, and highly relevant to real-world HSE practices. I appreciate their commitment to quality and would recommend TVE to anyone seeking credible certification in occupational health and safety, and Especially thanks to our tutor and coordinator. He is very cooperative, well mannered, well educative, well responsive.Thankyou very much once again, Have a great day ahead!',
      date: '2023-11-25'
    },
    {
      id: 16,
      name: 'Abraham Ebenezar',
      rating: 5,
      comment: 'Good',
      date: '2023-11-25'
    },
    {
      id: 17,
      name: 'Teby Terance',
      rating: 2,
      comment: 'I recently completed the ISO 9001:2015 Lead Auditor training course with TVE Training Institute and successfully passed the online exam. The entire experience was smooth',
      date: '2023-11-25'
    },
    {
      id: 18,
      name: 'Abhilash K Girijan',
      rating: 5,
      comment: 'I m pleased to share that I recently completed the ISO 9001:2015 Lead Auditor Training Course with TVE Training Institute and successfully passed the online exam. The entire experience was professional and highly informative. The course material was well-structured and easy to follow, even in the online format. The trainers were extremely knowledgeable and supportive, always available to clarify doubts and guide us through complex topics with practical insights. I truly recommend TVE to anyone looking to enhance their career and pursue professional auditor training in ISO standards.',
      date: '2023-11-25'
    },
    {
      id: 19,
      name: 'Liju Daniel',
      rating: 5,
      comment: 'No words to say, They are high level Proffessionals. Top notch tutoring.',
      date: '2023-11-25'
    },
    {
      id: 20,
      name: 'ovie',
      rating: 5,
      comment: 'Course delivery was nice. Instructor was very supportive',
      date: '2023-11-25'
    },
    {
      id: 21,
      name: 'Faiaz Ahamed',
      rating: 5,
      comment: 'The training had a good knowledge and experience which helps to understand the concepts of QMS. And the trainers were supportive during the session and cleared the doubts. The institute were supported in all enquiries and responsive.',
      date: '2023-11-25'
    },
    {
      id: 22,
      name: 'Ravi Ravi',
      rating: 5,
      comment: 'I recently completed the ISO 9001:2015 Lead Auditor training course with TVE Training Institute and successfully passed the online exam. The entire experience was smooth, professional, and very informative. The course material was well-structured, up-to-date, and easy to follow, even in an online format.I would like to thank tutor Mr.Jayakannan who is very knowledgeable and supportive and always available to clarify doubts and guide all topics..I highly recommend TVE to anyone looking to pursue professional auditor training in ISO standards. Special Thanks to Mr. lijaz for coordinating and clarifying And Im looking forward to do other courses in future in TVE. Thank u so much',
      date: '2023-11-25'
    },
    {
      id: 23,
      name: 'Vijay A',
      rating: 5,
      comment: 'Coordinator Mr Ahmed is excellent and i completed training session with excellent trainer Ms Janani.... thanks TVE Centre for providing support for Lead auditor courses keep up the best in future sessions too',
      date: '2023-11-25'
    },
    {
      id: 24,
      name: 'gnana sundaram',
      rating: 5,
      comment: '',
      date: '2023-11-25'
    },
    {
      id: 25,
      name: 'kumaravel kumar',
      rating: 5,
      comment: 'I recently completed ISO 9001:2015 Lead Auditor course training at TVE Certification Services and I am very satisfied with the experience. The trainer was highly knowledgeable and explained the concepts clearly with practical examples that made it easy to understand quality management principles. The training material was comprehensive and aligned well with the ISO 9001:2015 standard requirements. The institute provided good support during and after the training, and the certification process was smooth. I would definitely recommend [TVE Certification Services] to anyone looking to gain a strong foundation in ISO 9001:2015. Thanks to all...',
      date: '2023-11-25'
    },
    {
      id: 26,
      name: 'Harish Pothepalli',
      rating: 5,
      comment: 'Recently completed ISO 9001 and ISO 14001 Lead Auditor training and found it extremely valuable and well-structured. The course provided a clear understanding of quality management principle, process-based thinking and importance of continual improvement.',
      date: '2023-11-25'
    },
    {
      id: 27,
      name: 'Densingh',
      rating: 5,
      comment: 'Very good training institute. I have completed my ISO 9001 LEAD AUDITOR',
      date: '2023-11-25'
    },
    {
      id: 28,
      name: 'rodelito cabulay',
      rating: 5,
      comment: 'I got my IRCA Certification through TVE. TVE services are ideal and would highly recommend for those seeking certification for various disciplines.',
      date: '2023-11-25'
    },
    {
      id: 29,
      name: 'Lalit Babariya',
      rating: 5,
      comment: 'I have completed the ISO 9001:2015 Lead Auditor training course with TVE Training, and successfully passed the exam. The entire experience was smooth, professional, and very informative. The course material is well-structured and up-to-date. The trainer has good knowledge. I highly recommend TVE to anyone looking to pursue professional auditor training in ISO standards. Thank you TVE team',
      date: '2023-11-25'
    },
    {
      id: 30,
      name: 'Thyagarajan',
      rating: 5,
      comment: '',
      date: '2023-11-25'
    },
    {
      id: 31,
      name: 'thofa sriram',
      rating: 5,
      comment: 'I recently attended ISO 9001:2015 LA Course in TVE International and cleared it. The entire curriculum is very supportive for working professionals and even the staff and trainers are very supportive.',
      date: '2023-11-25'
    },
    {
      id: 32,
      name: 'Ram Kumar',
      rating: 5,
      comment: 'I m pleased to share that I have successfully completed the ISO Lead Auditor Course conducted by TVE Cert, an organization with a long-standing reputation in delivering quality auditor training, accredited by CQI-IRCA. The course was well-structured, informative, and highly practical. A special thanks to Mr. Karthik, our tutor, whose deep knowledge, clear explanations, and engaging teaching style made complex concepts easy to understand. His guidance throughout the sessions was immensely valuable. I d also like to express my appreciation to Mr. Ijaz, who coordinated the course seamlessly and provided constant support to ensure a smooth learning experience from start to finish.',
      date: '2023-11-25'
    },
    {
      id: 33,
      name: 'Sabir Niyazi',
      rating: 5,
      comment: 'TVE has Experienced Faculty, I have obtained ISO 14001, 45001 & 50001 certifications',
      date: '2023-11-25'
    },
    {
      id: 34,
      name: 'Irsad Mohamed',
      rating: 5,
      comment: 'I am pleased to share that I have successfully passed the ISO 45001 Lead Auditor examination. I would like to express my sincere gratitude to TVE International Academy Pvt. Ltd. for their exceptional training program. The course was well-structured, highly interactive, and delivered with professionalism and clarity. Mr. Stepan Johnson is my trainer, the trainers demonstrated deep subject knowledge, real-world auditing experience, and a genuine commitment to ensuring every participant gained confidence in both theoretical understanding and practical application. This training has greatly enhanced my auditing skills and overall understanding of ISO 45001. I highly recommend TVE International Academy to anyone seeking quality IRCA-accredited auditor training. Thank you once again for your excellent guidance and support throughout the course.',
      date: '2023-11-25'
    },
    {
      id: 35,
      name: 'Shiva Shankar',
      rating: 5,
      comment: 'Very good institute for certification. Well trained with experience tutor. Very kind & help full till we get certified.',
      date: '2023-11-25'
    },
    {
      id: 36,
      name: 'kalidas kalidas',
      rating: 5,
      comment: 'நீங்க படிக்காமலே பாஸ் ஆகலாம் கிளாஸ் ah ஒழுங்கா கவனிச்சா அப்படி ஒரு கிளாஸ் குடுப்பாங்க',
      date: '2023-11-25'
    },
    {
      id: 37,
      name: 'Nasser AL-Hinai',
      rating: 5,
      comment: 'Good institute',
      date: '2023-11-25'
    },
    {
      id: 38,
      name: 'Jagadeesh S.D',
      rating: 5,
      comment: 'Well experienced staffs in training',
      date: '2023-11-25'
    },
    {
      id: 39,
      name: 'Pravin Bhadane',
      rating: 5,
      comment: 'Excellent service',
      date: '2023-11-25'
    },
    {
      id: 40,
      name: 'Afzal Hashmi',
      rating: 5,
      comment: 'I completed the ISO 9001:2015 Lead Auditor certification through this institution via an online program. The course consisted of six days of virtual learning sessions conducted over Zoom. The instructors were highly professional and demonstrated strong expertise in auditing. Additionally, the customer support team was friendly and responsive, which enhanced the overall experience.',
      date: '2023-11-25'
    },
    {
      id: 41,
      name: 'Ron Ros',
      rating: 5,
      comment: 'I am pleased to share that I have successfully completed my ISO 9001:2015 Lead Auditor course with TVE International Academy Pvt Ltd. The instructor were very cooperative and knowledgeable, and they taught the course material very well.',
      date: '2023-11-25'
    },
    {
      id: 42,
      name: 'alwin jagadish',
      rating: 5,
      comment: 'I have completed ISO lead auditor course and had wonderful trainers for the online program',
      date: '2023-11-25'
    },
    {
      id: 43,
      name: 'muthukannan s',
      rating: 5,
      comment: 'very nice Organisation good faculties talented tutors and good result oriented, kee it up.',
      date: '2023-11-25'
    },
    {
      id: 44,
      name: 'Ananthitha Anandan',
      rating: 5,
      comment: 'Experienced trainer and good support from staff',
      date: '2023-11-25'
    },
    {
      id: 45,
      name: 'Guna Sekaran',
      rating: 5,
      comment: 'Great experience with my QMS ISO 9001 training here! The sessions were clear, practical, and very well-organized. The trainer "Mr. Pathy Naidu was highly knowledgeable and supportive. I m fully satisfied and will continue my remaining ISO trainings (14001, 45001) at the same center. Highly recommended',
      date: '2023-11-25'
    },
    {
      id: 46,
      name: 'AK Palani',
      rating: 5,
      comment: 'Excellent training imparted and support from all staff is highly appreciable',
      date: '2023-11-25'
    },
    {
      id: 47,
      name: 'Al-Khidief Alawaddin',
      rating: 5,
      comment: 'Helpful, accommodating, and very supportive. Highly recommended.',
      date: '2023-11-25'
    },
    {
      id: 48,
      name: 'sathish v',
      rating: 5,
      comment: 'I recently completed the ISO 14001 Lead Auditor Course with TVE and had an excellent learning experience. Well-structured training sessions, Experienced and supportive faculty Smooth administration and warm hospitality High-quality course materials I truly recommend TVE for anyone looking for professional, effective, and well-organized auditor training.',
      date: '2023-11-25'
    },
  ];